import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'
import { StateType } from 'domain/types/base/base';
import { AppThunk, } from 'base/src/utils/reducerUtil';
import { BY_RESUMO_CAMPANHA, BY_USUARIO_CAMPANHA } from '../../../types/produto/produto';
import { CampanhaProdutosService } from '../../../services/campanhaProduto/campanhaProdutoService';

const _CampanhaProdutosService = new CampanhaProdutosService();

export function GetByUsuarioCampanha(usuarioId: number, campanhaId: number, callback: () => void): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(BY_USUARIO_CAMPANHA, DispatchType.LOADING, 'Carregando', StateType.Master))
    const asyncResponse = await _CampanhaProdutosService.GetByUsuarioCampanha(usuarioId, campanhaId);

    if (ResponseValid(asyncResponse, false, dispatch)) {
      dispatch({
        payload: asyncResponse,
        type: BY_USUARIO_CAMPANHA
      })

      callback();

      dispatch(DispatchLoading(BY_USUARIO_CAMPANHA, DispatchType.SUCCESS));
    }
  }
}

export function GetResumoCampanha(usuarioId: number, campanhaId: number, campanhaPedidoResgateId: number, callback: () => void): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(BY_RESUMO_CAMPANHA, DispatchType.LOADING, 'Carregando', StateType.Master))
    const asyncResponse = await _CampanhaProdutosService.GetResumoCampanha(usuarioId, campanhaId, campanhaPedidoResgateId);

    if (ResponseValid(asyncResponse, false, dispatch)) {
      dispatch({
        payload: asyncResponse,
        type: BY_RESUMO_CAMPANHA
      })

      callback();

      dispatch(DispatchLoading(BY_RESUMO_CAMPANHA, DispatchType.SUCCESS));
    }
  }
}